import { h } from 'preact'
import { i18n } from 'i18n/i18n'

import { Calculation } from 'models/exchange-transfer-calculate'

import { formatRate } from 'utils/format-number'
import { base, counter } from 'app-utils/rate-order'

interface CalculatorActualRateProps {
  baseCurrency: string
  counterCurrency: string
  exchangeData: Calculation
  allCurrencies: string[]
}

const CalculatorActualRate = ({
  baseCurrency,
  counterCurrency,
  exchangeData,
  allCurrencies,
}: CalculatorActualRateProps) => {
  /**
   * Rates are displayed according to the dominant currency in the pair
   * The dominant currency is determined based on the order returned by the API
   * The currency order array is located in /settings?keys[]=currency under the name "symbols"
   * The following variables are used to display the rate in the correct order
   */
  const baseRateCurrency = base(baseCurrency, counterCurrency, allCurrencies)
  const counterRateCurrency = counter(baseCurrency, counterCurrency, allCurrencies)
  const currencyPair = `${baseCurrency}_${counterCurrency}`
  const rateFormated = formatRate(exchangeData.average_rate, currencyPair)

  return (
    <p className="calc-widget__actual-rate">
      {i18n('widgetCalculator.actualRate')} 1 {baseRateCurrency} = {rateFormated} {counterRateCurrency}
    </p>
  )
}

export default CalculatorActualRate
